export default {
  name: 'FileMixin',
  methods: {
    normalizePath(path) {
      return (path || '').replace(/\\/g, '/').replace(/\/+$/g, '');
    },

    commonPath(paths) {
      if (!paths?.length) return '';

      const partsList = paths
        .map(this.normalizePath)
        .map((p) => p.split('/').filter(Boolean));

      const commonParts = partsList.slice(1).reduce((acc, parts) => {
        const max = Math.min(acc.length, parts.length);

        return acc.slice(0, max).reduce(
          (state, seg, idx) => {
            if (!state.keep) return state;
            if (seg === parts[idx]) state.out.push(seg);
            else state.keep = false;
            return state;
          },
          { keep: true, out: [] },
        ).out;
      }, partsList[0] || []);

      return commonParts.join('/');
    },
  },
};
